import { Fragment, useMemo } from 'react';
import { Circle, Container, Label, Line, Step } from './StepTracker.styles';
import { StepTrackerProps } from './StepTracker.types';

const StepTracker: React.FC<StepTrackerProps> = ({ steps, currentStep }) => {
  const renderSteps = useMemo(
    () =>
      steps.map((step, index) => {
        const isCurrentStep = currentStep === index;
        const isFutureStep = currentStep < index;
        const isPastStep = currentStep > index;
        return (
          <Fragment key={step.label}>
            {index !== 0 && <Line isFutureStep={isFutureStep} />}            <Step
              tabIndex={isPastStep ? 0 : undefined}
              onClick={isPastStep && step.onClick ? () => step.onClick?.() : undefined}
              isCurrentStep={isCurrentStep}
              isFutureStep={isFutureStep}
              isPastStep={isPastStep}
              as={isPastStep ? 'button' : 'div'}
              data-testid={`step-${index}`}
            >
              <Label isCurrentStep={isCurrentStep}>{step.label}</Label>
              <Circle isFutureStep={isFutureStep}>{index + 1}</Circle>
            </Step>
          </Fragment>
        );
      }),
    [currentStep, steps]
  );
  return <Container>{renderSteps}</Container>;
};

export default StepTracker;
